import api from './authService';

export const vendorContractApi = {
  list: async (params = {}) => {
    const response = await api.get('/vendor/contracts', { params });
    return response.data;
  },
  templates: async () => {
    const response = await api.get('/vendor/contracts/templates');
    return response.data;
  },
  getOne: async (id) => {
    const response = await api.get(`/vendor/contracts/${id}`);
    return response.data;
  },
  create: async (payload) => {
    const response = await api.post('/vendor/contracts', payload);
    return response.data;
  },
  update: async (id, payload) => {
    const response = await api.put(`/vendor/contracts/${id}`, payload);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/vendor/contracts/${id}`);
    return response.data;
  },
  sendEmail: async (id, payload = {}) => {
    const response = await api.post(`/vendor/contracts/${id}/send-email`, payload);
    return response.data;
  },
  refreshLink: async (id) => {
    const response = await api.post(`/vendor/contracts/${id}/refresh-link`);
    return response.data;
  },
};

export const publicContractApi = {
  getByToken: async (token) => {
    const response = await api.get(`/public/contracts/${encodeURIComponent(token)}`);
    return response.data;
  },
  sign: async (token, payload) => {
    const response = await api.post(`/public/contracts/${encodeURIComponent(token)}/sign`, payload);
    return response.data;
  },
};

export function applyContractPlaceholders(html, vars = {}) {
  let out = String(html || '');
  Object.entries(vars).forEach(([key, value]) => {
    const safe = value == null || value === '' ? '—' : String(value);
    out = out.split(`{{${key}}}`).join(safe);
  });
  return out;
}
